const es = {
  dialog: 'Luna, asistente virtual de {site}',
  open: 'Abrir chat con Luna de {site}',
  launcher: 'Chat con Luna',
  subtitle: 'Consultas sobre {site}',
  close: 'Cerrar chat',
  welcome: 'Hola, soy Luna, asistente virtual de {site}.',
  description:
    'Puedes preguntarme sobre {site}. La conversación se guarda para mantener el contexto y darte una respuesta útil.',
  consent: 'Acepto el tratamiento de esta conversación según la',
  privacy: 'política de privacidad',
  start: 'Iniciar conversación',
  recovering: 'Recuperando conversación…',
  ready: 'Listo para ayudarte',
  empty:
    'Soy Luna, asistente virtual de {site}. Cuéntame qué necesitas; puedes continuar la conversación sin repetir lo que ya dijiste.',
  typing: 'Luna está escribiendo',
  retry: 'Reintentar',
  placeholder: 'Escribe tu consulta',
  message: 'Mensaje',
  send: 'Enviar mensaje',
  disclosure: 'La IA puede equivocarse. Verifica decisiones importantes.',
  expired: 'La sesión del chat venció. Estamos creando una sesión nueva.',
  unavailable: 'El chat no está disponible en este momento.',
  sendFailure: 'No pudimos confirmar la entrega. Reintenta el mismo mensaje.',
  answerFailure:
    'Tu consulta se recibió. Luna no pudo completar la respuesta; puedes reintentar o continuar con otra pregunta.',
  reviewPending:
    'Tu consulta se recibió y está pendiente de revisión. Puedes continuar en este chat.',
  retryAnswer: 'Reintentar respuesta',
  continueConversation: 'Continuar con otra pregunta',
  rateLimit:
    'Se alcanzó el límite de nuevas conversaciones. Intenta nuevamente en {minutes} minutos.',
} as const;
export type SupportChatCopy = { [Key in keyof typeof es]: string };
const en: SupportChatCopy = {
  dialog: 'Luna, virtual assistant for {site}',
  open: 'Open chat with Luna for {site}',
  launcher: 'Chat with Luna',
  subtitle: 'Questions about {site}',
  close: 'Close chat',
  welcome: 'Hi, I’m Luna, virtual assistant for {site}.',
  description:
    'Ask me about {site}. Your conversation is saved so I can keep context and help you.',
  consent: 'I agree to the processing of this conversation under the',
  privacy: 'privacy policy',
  start: 'Start conversation',
  recovering: 'Loading conversation…',
  ready: 'Ready to help',
  empty:
    'I’m Luna, virtual assistant for {site}. Tell me what you need; you can continue without repeating what you already said.',
  typing: 'Luna is typing',
  retry: 'Retry',
  placeholder: 'Write your question',
  message: 'Message',
  send: 'Send message',
  disclosure: 'AI can make mistakes. Verify important decisions.',
  expired: 'Your chat session expired. We are creating a new session.',
  unavailable: 'Chat is unavailable at the moment.',
  sendFailure: 'We could not confirm delivery. Retry the same message.',
  answerFailure:
    'Your question was received. Luna could not complete the answer; retry or continue with another question.',
  reviewPending:
    'Your question was received and is awaiting review. You can continue in this chat.',
  retryAnswer: 'Retry answer',
  continueConversation: 'Continue with another question',
  rateLimit:
    'The new conversation limit was reached. Try again in {minutes} minutes.',
};
export function getSupportChatCopy(language: string): SupportChatCopy {
  return language.startsWith('en') ? en : es;
}
